import { useSearchParams } from 'react-router-dom';
import { PREVIEW_QUERY_PARAM } from '../utils/appointmentStageRouting';

/**
 * Returns true when the current URL contains `?preview=true`. Strict equality
 * ensures only the exact value "true" activates preview mode — variants like
 * "1" or "yes" do not count. Used by module pages to determine whether they
 * were opened from a Preview button on the overview.
 */
export function useIsPreviewMode() {
  const [searchParams] = useSearchParams();
  return searchParams.get(PREVIEW_QUERY_PARAM) === 'true';
}
